var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ml-4 mr-4" },
    [
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes,\n              arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right ml-5",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: { click: _vm.save }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _vm.form_type === 0
              ? [
                  _c("CompaniesWebQuoteSelect", {
                    attrs: { company: _vm.company },
                    on: {
                      setStepEditing: function($event) {
                        _vm.setFormType(1)
                      },
                      setStepCustom: function($event) {
                        _vm.setFormType(2)
                      },
                      setStepIframe: function($event) {
                        _vm.setFormType(3)
                      }
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.form_type === 1
              ? [
                  _vm.loading
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 450 } },
                          _vm._l(15, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.4,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _c("div", { staticClass: "row l-m-b-16" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("h2", { staticClass: "l-header-2" }, [
                              _vm._v("Button position")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "section-disclaimer" }, [
                              _vm._v(
                                "\n              You can select a button position, where you want it to appear on your website.\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3 mt-4" }, [
                              _c("div", { staticClass: "d-flex col-12" }, [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex flex-column col-6 pl-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "check-field mb-3" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            class: [
                                              _vm.buttonPosition.includes("1")
                                                ? "check-open"
                                                : ""
                                            ],
                                            attrs: { for: "centered" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "checkmark"
                                            }),
                                            _vm._v(
                                              "Left side\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.buttonPosition,
                                                  expression: "buttonPosition"
                                                }
                                              ],
                                              staticClass: "btn-check",
                                              attrs: {
                                                type: "checkbox",
                                                id: "centered"
                                              },
                                              domProps: {
                                                value: 1,
                                                checked: Array.isArray(
                                                  _vm.buttonPosition
                                                )
                                                  ? _vm._i(
                                                      _vm.buttonPosition,
                                                      1
                                                    ) > -1
                                                  : _vm.buttonPosition
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        _vm.buttonPosition,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = 1,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.buttonPosition = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.buttonPosition = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.buttonPosition = $$c
                                                    }
                                                  },
                                                  _vm.uniqueCheck
                                                ]
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "option-explanation" },
                                      [
                                        _vm._v(
                                          "\n                    With this option the button will be sticky in the lower left corner of the screen.\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3 mt-4" }, [
                              _c("div", { staticClass: "d-flex col-12" }, [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex col-6 flex-column pl-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "check-field mb-3" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            class: [
                                              _vm.buttonPosition.includes("2")
                                                ? "check-open"
                                                : ""
                                            ],
                                            attrs: { for: "sticky" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "checkmark"
                                            }),
                                            _vm._v(
                                              "Right side\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.buttonPosition,
                                                  expression: "buttonPosition"
                                                }
                                              ],
                                              staticClass: "btn-check",
                                              attrs: {
                                                type: "checkbox",
                                                id: "sticky"
                                              },
                                              domProps: {
                                                value: 2,
                                                checked: Array.isArray(
                                                  _vm.buttonPosition
                                                )
                                                  ? _vm._i(
                                                      _vm.buttonPosition,
                                                      2
                                                    ) > -1
                                                  : _vm.buttonPosition
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        _vm.buttonPosition,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = 2,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.buttonPosition = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.buttonPosition = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.buttonPosition = $$c
                                                    }
                                                  },
                                                  _vm.uniqueCheck
                                                ]
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "option-explanation" },
                                      [
                                        _vm._v(
                                          "\n                    With this option the button will be sticky in the lower right corner of the screen.\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" }, [
                            _c("h2", { staticClass: "l-header-2" }, [
                              _vm._v("Button colors")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "section-disclaimer" }, [
                              _vm._v(
                                "\n              You can choose your own color for the button and text. Enter hex for desired colors.\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4 mt-4" }, [
                              _c("div", { staticClass: "col pr-1" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c("label", [_vm._v("Primary color")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.solidBackground.backgroundColor,
                                        expression:
                                          "solidBackground.backgroundColor"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      autocomplete: "no",
                                      placeholder: "Enter #",
                                      maxlength: "7"
                                    },
                                    domProps: {
                                      value: _vm.solidBackground.backgroundColor
                                    },
                                    on: {
                                      change: _vm.styleButton,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.solidBackground,
                                          "backgroundColor",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c("label", [_vm._v("Secondary color")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.solidText.color,
                                        expression: "solidText.color"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      autocomplete: "no",
                                      placeholder: "Enter #",
                                      maxlength: "7"
                                    },
                                    domProps: { value: _vm.solidText.color },
                                    on: {
                                      change: _vm.styleButtonText,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.solidText,
                                          "color",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "l-header-2" }, [
                              _vm._v("Button style")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "section-disclaimer" }, [
                              _vm._v(
                                "\n              You can choose a style for the button.\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3 mt-2 pl-3" }, [
                              _c("div", { staticClass: "row mb-3 mt-4" }, [
                                _c("div", { staticClass: "d-flex col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex col-6 pl-0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "solid-button button-full",
                                          style: _vm.solidBackground
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-uppercase",
                                              style: _vm.solidText
                                            },
                                            [
                                              _vm._v(
                                                "\n                        quick quote\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column col-6 pl-0"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "check-field mb-3" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              class: [
                                                _vm.buttonStyle.includes("1")
                                                  ? "check-open"
                                                  : ""
                                              ],
                                              attrs: { for: "solid" }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "checkmark"
                                              }),
                                              _vm._v(
                                                "Solid button\n                        "
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.buttonStyle,
                                                    expression: "buttonStyle"
                                                  }
                                                ],
                                                staticClass: "btn-check",
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "solid"
                                                },
                                                domProps: {
                                                  value: 1,
                                                  checked: Array.isArray(
                                                    _vm.buttonStyle
                                                  )
                                                    ? _vm._i(
                                                        _vm.buttonStyle,
                                                        1
                                                      ) > -1
                                                    : _vm.buttonStyle
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a = _vm.buttonStyle,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = 1,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.buttonStyle = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.buttonStyle = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.buttonStyle = $$c
                                                      }
                                                    },
                                                    _vm.uniqueCheckButtonStyle
                                                  ]
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option-explanation" },
                                        [
                                          _vm._v(
                                            "\n                      With this option the button will be in one solid color taken from your primary color.\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-3 mt-4" }, [
                                _c("div", { staticClass: "d-flex col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex col-6 pl-0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "outline-button button-full",
                                          style: _vm.outlineBackground
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-uppercase",
                                              style: _vm.outlineText
                                            },
                                            [
                                              _vm._v(
                                                "\n                        quick quote\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex col-6 flex-column pl-0"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "check-field mb-3" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              class: [
                                                _vm.buttonStyle.includes("2")
                                                  ? "check-open"
                                                  : ""
                                              ],
                                              attrs: { for: "outline" }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "checkmark"
                                              }),
                                              _vm._v(
                                                "Outline button\n                        "
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.buttonStyle,
                                                    expression: "buttonStyle"
                                                  }
                                                ],
                                                staticClass: "btn-check",
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "outline"
                                                },
                                                domProps: {
                                                  value: 2,
                                                  checked: Array.isArray(
                                                    _vm.buttonStyle
                                                  )
                                                    ? _vm._i(
                                                        _vm.buttonStyle,
                                                        2
                                                      ) > -1
                                                    : _vm.buttonStyle
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a = _vm.buttonStyle,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = 2,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.buttonStyle = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.buttonStyle = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.buttonStyle = $$c
                                                      }
                                                    },
                                                    _vm.uniqueCheckButtonStyle
                                                  ]
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option-explanation" },
                                        [
                                          _vm._v(
                                            "\n                      With this option the button will have an outline and text in your primary color.\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row l-m-b-16" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("h2", { staticClass: "l-header-2" }, [
                              _vm._v("Form style")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "section-disclaimer" }, [
                              _vm._v(
                                "\n              Choose between side modal opening or a simple pop-up modal for your quick quote form.\n              For both styles the form will remain the same on mobile devices.\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3 mt-4" }, [
                              _c("div", { staticClass: "d-flex col-12" }, [
                                _vm._m(2),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex flex-column col-6 pl-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "check-field mb-3" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            class: [
                                              _vm.modalPosition.includes("1")
                                                ? "check-open"
                                                : ""
                                            ],
                                            attrs: { for: "side" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "checkmark"
                                            }),
                                            _vm._v(
                                              "Side modal\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.modalPosition,
                                                  expression: "modalPosition"
                                                }
                                              ],
                                              staticClass: "btn-check",
                                              attrs: {
                                                type: "checkbox",
                                                id: "side"
                                              },
                                              domProps: {
                                                value: 1,
                                                checked: Array.isArray(
                                                  _vm.modalPosition
                                                )
                                                  ? _vm._i(
                                                      _vm.modalPosition,
                                                      1
                                                    ) > -1
                                                  : _vm.modalPosition
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a = _vm.modalPosition,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = 1,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.modalPosition = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.modalPosition = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.modalPosition = $$c
                                                    }
                                                  },
                                                  _vm.uniqueCheckModal
                                                ]
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "option-explanation" },
                                      [
                                        _vm._v(
                                          "\n                    With this option the modal will open from the right side of the screen.\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3 mt-4" }, [
                              _c("div", { staticClass: "d-flex col-12" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex col-6 flex-column pl-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "check-field mb-3" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            class: [
                                              _vm.modalPosition.includes("2")
                                                ? "check-open"
                                                : ""
                                            ],
                                            attrs: { for: "pop-up" }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "checkmark"
                                            }),
                                            _vm._v(
                                              "Pop-up\n                      "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.modalPosition,
                                                  expression: "modalPosition"
                                                }
                                              ],
                                              staticClass: "btn-check",
                                              attrs: {
                                                type: "checkbox",
                                                id: "pop-up"
                                              },
                                              domProps: {
                                                value: 2,
                                                checked: Array.isArray(
                                                  _vm.modalPosition
                                                )
                                                  ? _vm._i(
                                                      _vm.modalPosition,
                                                      2
                                                    ) > -1
                                                  : _vm.modalPosition
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a = _vm.modalPosition,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = 2,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.modalPosition = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.modalPosition = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.modalPosition = $$c
                                                    }
                                                  },
                                                  _vm.uniqueCheckModal
                                                ]
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "option-explanation" },
                                      [
                                        _vm._v(
                                          "\n                    With this option the modal will open as a pop-up in the middle of the screen.\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" }, [
                            _c("h2", { staticClass: "l-header-2" }, [
                              _vm._v("Script for your website")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "section-disclaimer" }, [
                              _vm._v(
                                "\n              Click on the text below to copy the script to clipboard. Add it to your HTML app by pasting it before </body> tag.\n              "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "assistance",
                                  attrs: { href: "#" },
                                  on: { click: _vm.toggleAssistanceModal }
                                },
                                [_vm._v("Need more assistance?")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row mb-3 mt-3 pl-3 pr-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "select-wrap h-auto" },
                                  [
                                    _c(
                                      "textarea",
                                      {
                                        ref: "script",
                                        staticClass:
                                          "select-wrap-textarea form-control",
                                        attrs: { rows: "8" },
                                        on: { click: _vm.doCopy }
                                      },
                                      [
                                        _vm._v(
                                          '<script id="mod24-widget" src="' +
                                            _vm._s(
                                              _vm.url === "production"
                                                ? "https://widget.mod24.com/widget.js"
                                                : "https://widget.24mod.com/widget.js"
                                            ) +
                                            '" company-key="' +
                                            _vm._s(_vm.company.web_key) +
                                            '" button-position="' +
                                            _vm._s(_vm.buttonPosition[0]) +
                                            '" button-style="' +
                                            _vm._s(_vm.buttonStyle[0]) +
                                            '" modal-position="' +
                                            _vm._s(_vm.modalPosition[0]) +
                                            '" color-primary="' +
                                            _vm._s(
                                              _vm.solidBackground
                                                .backgroundColor
                                            ) +
                                            '" color-secondary="' +
                                            _vm._s(
                                              _vm.outlineBackground
                                                .backgroundColor
                                            ) +
                                            '" async></script>\n              '
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row mt-3 pl-3 pr-3 d-flex justify-content-end"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "assistance",
                                    on: {
                                      click: function($event) {
                                        _vm.setFormType(2)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Switch to custom form?\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row mt-3 pl-3 pr-3 d-flex justify-content-end"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "assistance",
                                    on: {
                                      click: function($event) {
                                        _vm.setFormType(3)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Switch to iframe form?\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.form_type === 2
              ? [
                  _c("CompaniesWebQuoteCustom", {
                    attrs: { company: _vm.company },
                    on: {
                      setStepEditing: function($event) {
                        _vm.setFormType(1)
                      },
                      setStepIframe: function($event) {
                        _vm.setFormType(3)
                      }
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.form_type === 3
              ? [
                  _c("CompaniesWebQuoteIframe", {
                    attrs: { company: _vm.company },
                    on: {
                      setStepEditing: function($event) {
                        _vm.setFormType(1)
                      },
                      setStepCustom: function($event) {
                        _vm.setFormType(2)
                      },
                      setStepIframe: function($event) {
                        _vm.setFormType(3)
                      }
                    }
                  })
                ]
              : _vm._e()
          ],
      _vm._v(" "),
      _vm.assistanceModal
        ? _c(
            "modal",
            {
              attrs: { size: "l-modal-large" },
              on: { close: _vm.toggleAssistanceModal }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h1", [_vm._v("Web Quote Assistant")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  [
                    _c("div", { staticClass: "container-fluid" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 pl-0" }, [
                          _c(
                            "div",
                            { staticClass: "assistance-content mt-2 mb-3" },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                  Simply copy the script from the web quote page and insert it at the bottom of your content, just before the </body> tag of your HTML Application:\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("code", [
                                _c("div", [
                                  _vm._v(
                                    "\n                    <head>...</head>\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    <body>\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    <h1<Hello World!</h1>\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("b", [_vm._v("Insert script here")])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    </body>\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                    </html>\n                  "
                                  )
                                ])
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("span")
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex col-6 pl-0" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/img/quote_left.png"),
          width: "240",
          alt: "Quote in center"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex col-6 pl-0" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/img/quote_right.png"),
          width: "240",
          alt: "Quote on edge of screen"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex col-6 pl-0" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/img/side-modal.gif"),
          width: "240",
          alt: "Side modal example"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex col-6 pl-0" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/img/pop-up.gif"),
          width: "240",
          alt: "Pop-up modal"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5657fdcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5657fdcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesWebQuote.vue
// module id = null
// module chunks = 